<template>
    <div class="color-select">
        <p v-if="label" class="caption grey--text text--darken-1">{{ label }}</p>

        <div class="custom-radio-group">
            <v-tooltip bottom v-for="item in items" :key="item.value">
                <template v-slot:activator="{ on }">
                    <label
                        class="radio"
                        :class="{
                            selected: getLabelClass(item),
                            readonly: readonly,
                            small: small
                        }"
                        :style="getStyle(item)"
                        v-ripple="{ center: true }"
                        v-on="on"
                    >
                        <input v-if="!checkbox" :disabled="readonly" type="radio" :value="item.value" v-model="selected"/>
                        <input
                            v-else
                            :disabled="readonly"
                            type="checkbox"
                            :value="item.value"
                            v-model="selected"
                            @change="onCheckboxChange(item.value, $event)"
                        />
                    </label>
                </template>
                <span>{{ item.value }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.color-select {
    .custom-radio-group {
        label {
            background-size: 100%;
            border-radius: 50%;
            display: inline-block;
            height: 30px;
            margin: 5px;
            position: relative;
            width: 30px;
            input {
                display: none;
            }

            &.small {
                width: 15px;
                height: 15px;
                margin: 0 5px;
                box-shadow: 1px 1px 2px rgba(0,0,0,0.25);
                margin-bottom: -3px;
            }

            &::before {
                border: 2px solid transparent;
                border-radius: 50%;
                content: '';
                height: 40px;
                left: -5px;
                position: absolute;
                top: -5px;
                transition: 0.2s;
                width: 40px;
            }

            &.small::before {
                left: -4px;
                top: -4px;
            }

            &.small::before {
                width: 23px;
                height: 23px;
            }

            &:not(.readonly):hover,
            &.selected {
                &::before {
                    border-color: #414141;
                }
            }
        }
    }
}
</style>

<script>
export default {
    name: 'ColorSelector',
    props: {
        label: String,
        value: null,
        items: {
            type: Array,
            default: [],
        },
        readonly: Boolean,
        small: Boolean,
        checkbox: Boolean,
    },
    data() {
        return {
            selectedVal: null,
        };
    },
    computed: {
        selected: {
            get() {
                if (!this.selectedVal) {
                    this.selectedVal = this.checkbox ? (this.value ? this.value : []) : this.value;
                }
                return this.selectedVal;
            },
            set(value) {
                this.selectedVal = value;
            },
        }
    },
    methods: {
        getLabelClass(item) {
            if (this.checkbox) {
                return this.selected === item.value || this.selected.indexOf(item.value) !== -1;
            } else {
                return this.selected === item.value;
            }
        },
        getStyle(item) {
            const style = {};
            const value = item.text ? item.text : '';
            if (value.length > 0) {
                if (value.indexOf('#') === 0) {
                    style['background-color'] = value;
                } else {
                    style['background-image'] = `url(${value})`;
                }
            }
            return style;
        },
        onCheckboxChange(attributeValue, event) {
            this.$emit('change', {
                attributeValue,
                value: this.selected.indexOf(attributeValue) !== -1,
            });
        },
    },
    watch: {
        selected(val) {
            this.$emit('input', val);
        },
    },
};
</script>
